<template>
  <b-card :title="title" class="h-100">
    <div v-if="!rows || !rows.length" class="text-center text-muted py-2">Нет данных</div>
    <table v-else class="table table-sm table-borderless mb-0">
      <thead>
        <tr class="text-muted font-small-2">
          <th class="pl-0">#</th>
          <th>Название</th>
          <th class="text-right pr-0">{{ valueLabel }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="index">
          <td class="pl-0 text-muted">{{ index + 1 }}</td>
          <td class="text-truncate" style="max-width: 14rem">{{ rowName(row) }}</td>
          <td class="text-right pr-0 font-weight-bold">{{ formatValue(row[valueField]) }}</td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { formatRub } from '@/views/finance/utils'
import { formatNumber } from '@/views/dashboard/sifnf/utils'

export default {
  components: { BCard },
  props: {
    title: { type: String, required: true },
    rows: { type: Array, default: () => [] },
    nameField: { type: String, default: 'name' },
    valueField: { type: String, required: true },
    valueLabel: { type: String, default: '' },
    valueFormat: { type: String, default: 'number' },
  },
  setup(props) {
    const rowName = row => row[props.nameField] || row.tg_username || `id: ${row.host_id || row.pack_id || row.author_id || '?'}`
    const formatValue = value => (props.valueFormat === 'rub' ? formatRub(value) : formatNumber(value))
    return { rowName, formatValue }
  },
}
</script>
